

const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || "https://ogm-service-756477950725.asia-south1.run.app/api";

/**
 * Sends user_json_url to backend for phone verification.
 * Backend fetches phone.email servers to get the verified mobile number.
 *
 * @param {string} userJsonUrl - URL provided by phone.email widget
 * @returns {Promise<{ verified: boolean, mobile: string }>}
 */
export const verifyPhoneWithBackend = async (userJsonUrl) => {
    const res = await fetch(`${BACKEND_URL}/broker/verify-phone`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userJsonUrl }),
    });
    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || "Phone verification failed");
    }
    return await res.json();
};

export const verifyEmailWithBackend = async (userJsonUrl) => {
    const res = await fetch(`${BACKEND_URL}/broker/verify-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userJsonUrl }),
    });
    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || "Email verification failed");
    }
    return await res.json();
};
